import { filter } from 'rxjs/operators';
import { AreaVasta, AziendaSanitaria } from '@hm_app/@core/models/anagrafica_geo';
import { Component, OnInit, Input } from '@angular/core';
import { Struttura, ServizioStruttura, OrarioStruttura, TipologiaStruttura, TipoServizioStruttura } from '@hm_app/@core/models/struttura';
import { Provincia, Comune, Distretto } from '@hm_app/@core/models/anagrafica_geo';
import * as _ from 'lodash-es';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { StrutturaDetailComponent } from '@hm_app/shared/strutture/struttura-detail/struttura-detail.component';

@Component({
    selector: 'tutte-strutture',
    templateUrl: './tutte-strutture.component.html',
    styleUrls: ['./tutte-strutture.component.scss'],
})
export class TutteStruttureComponent implements OnInit {

    province: Provincia[];
    comuni: Comune[];
    distretti: Distretto[];
    aziende_sanitarie = new Array<AziendaSanitaria>();

    _strutture: Struttura[];

    servizi_strutture: ServizioStruttura[];
    orari_strutture: OrarioStruttura[];
    tipologie_struttura: TipologiaStruttura[];
    tipi_serv_strut: TipoServizioStruttura[];
    aree_vaste: AreaVasta[];

    _tipo_struttura_corrente_id: number;
    _area_vasta_corrente_id: number;
    _distretto_corrente_id: number;

    _strutture_filtered: Struttura[];
    distretti_filtered: Distretto[];


    tipi_struttura = [
        { id: 0, value: 'Tutte le strutture' },
        { id: 1, value: 'Ospedaliere' },
        { id: 2, value: 'Consultoriali' },
    ];

    constructor(private modalService: NgbModal, private hmService: HappyMammaService) { }

    async ngOnInit() {
        this.comuni = await this.hmService.comuniToscanaAllPromise();
        this.province = await this.hmService.provinceToscanaAllPromise();

        this.distretti = await this.hmService.distrettiWithMacrozonaPromise();
        this.aziende_sanitarie = await this.hmService.aziendeAllPromise();
        this.aree_vaste = await this.hmService.areeVasteAllPromise();
        this.strutture = await this.hmService.struttureAllPromise();

        this.strutture_filtered = this.strutture;
        this.distretti_filtered = this.distretti;
        this.tipo_struttura_corrente_id = 0;
    }

    set strutture_filtered(sf: Struttura[]) {
        this._strutture_filtered = sf;
    }

    get strutture_filtered(): Struttura[] {
        return this._strutture_filtered;
    }

    @Input() set strutture(sf: Struttura[]) {
        this._strutture = sf;
        this.strutture_filtered = this.strutture;
    }

    get strutture(): Struttura[] {
        return this._strutture;
    }

    set tipo_struttura_corrente_id(t: number) {
        this._tipo_struttura_corrente_id = t;
        this.filterStrutture();
    }
    get tipo_struttura_corrente_id(): number {
        return this._tipo_struttura_corrente_id;
    }

    set area_vasta_corrente_id(a: number) {
        this._area_vasta_corrente_id = a;
        this.distretto_corrente_id = null;
        this.filterStrutture();
    }
    get area_vasta_corrente_id(): number {
        return this._area_vasta_corrente_id;
    }

    set distretto_corrente_id(d: number) {
        this._distretto_corrente_id = d;
        this.filterStrutture();
    }
    get distretto_corrente_id(): number {
        return this._distretto_corrente_id;
    }


    filterStrutture() {
        let strutture_abbinate: Struttura[] = [];

        if (this.tipo_struttura_corrente_id && this.tipo_struttura_corrente_id != 0) {
            strutture_abbinate = _.filter(this.strutture, { tipologia_struttura: +this.tipo_struttura_corrente_id });
        } else {
            strutture_abbinate = this.strutture;
        }

        if (this.distretto_corrente_id) {
            const strutture_distretto = [];

            const distretto = _.find(this.distretti, { id: +this.distretto_corrente_id });

            if (distretto) {

                const consultori = _.filter(strutture_abbinate, { distretto: distretto.id, tipologia_struttura: 2 });
                for (const struttura of consultori) {
                    strutture_distretto.push(struttura);
                }
                const distretti_macrozona = _.filter(this.distretti, { macrozona: distretto.macrozona });
                for (const d of distretti_macrozona) {
                    const strutts = _.filter(strutture_abbinate, { distretto: d.id, tipologia_struttura: 1 });
                    for (const struttura of strutts) {
                        const azienda = _.filter(this.aziende_sanitarie, { id: struttura.azienda_sanitaria })[0];
                        if (!azienda.universitaria) {
                            strutture_distretto.push(struttura);
                        }
                    }
                }

                const aziende_universitarie = _.filter(this.aziende_sanitarie, { area_vasta: distretto.area_vasta, universitaria: true });
                for (const au of aziende_universitarie) {
                    const strutts = _.filter(strutture_abbinate, { azienda_sanitaria: au.id });
                    for (const struttura of strutts) {
                        strutture_distretto.push(struttura);
                    }
                }
            }
            strutture_abbinate = strutture_distretto;
        } else if (this.area_vasta_corrente_id) {
            strutture_abbinate = _.filter(strutture_abbinate, { area_vasta: +this.area_vasta_corrente_id });
            this.distretti_filtered = _.filter(this.distretti, { area_vasta: +this.area_vasta_corrente_id });
        }
        this.strutture_filtered = strutture_abbinate;


    }

    openDettaglioStruttura(s: Struttura) {
        const modal = this.modalService.open(StrutturaDetailComponent, { size: 'lg' });
        modal.componentInstance.struttura = s;
        // modal.componentInstance.servizi_strutture = this.servizi_strutture;
        // modal.componentInstance.tipi_serv_strut = this.tipi_serv_strut;
        // modal.componentInstance.orari_strutture = this.orari_strutture;
    }

    getNomeDistretto(d: number) {
        const distretto = _.find(this.distretti, { id: d });
        if (distretto) return distretto.nome;
    }

}
